(function () {
  if (window.customElements.get('cart-upsell-recommendations')) {
    return;
  }

  class CartUpsellRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._loaded) {
        return;
      }
      this._loaded = true;
      this._load();
    }

    _load() {
      const productId = this.getAttribute('product');
      if (!productId) {
        this.remove();
        return;
      }

      const intent = this.getAttribute('intent') || 'complementary';
      const limit = this.getAttribute('limit') || 4;
      const sectionId = this.getAttribute('section-id') || 'cart-upsell';
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const url =
        root +
        'recommendations/products?product_id=' +
        encodeURIComponent(productId) +
        '&intent=' +
        encodeURIComponent(intent) +
        '&limit=' +
        encodeURIComponent(limit) +
        '&section_id=' +
        encodeURIComponent(sectionId);

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const content = doc.querySelector('.cart-upsell');
          if (!content) {
            this.remove();
            return;
          }
          this.replaceChildren(content);
          this._initCarousel();
        })
        .catch(() => {
          this.remove();
        });
    }

    _initCarousel() {
      const viewport = this.querySelector('.cart-upsell__viewport');
      if (!viewport) {
        return;
      }

      const prev = this.querySelector('[data-upsell-prev]');
      const next = this.querySelector('[data-upsell-next]');

      const update = () => {
        if (!prev || !next) {
          return;
        }
        const maxScroll = viewport.scrollWidth - viewport.clientWidth - 1;
        prev.disabled = viewport.scrollLeft <= 0;
        next.disabled = viewport.scrollLeft >= maxScroll;
      };

      if (prev) {
        prev.addEventListener('click', () => {
          viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
        });
      }
      viewport.addEventListener('scroll', update, { passive: true });
      update();
    }
  }

  window.customElements.define('cart-upsell-recommendations', CartUpsellRecommendations);
})();